module.exports = __webpack_public_path__ + "media/pro/Meta-47fd39bf.png";